export default __webpack_public_path__ + "static/media/profitClouds.4df49d3a.jpg";